// environment.development.ts
export const environment = {
    production: false,
    environmentName: 'development'
};
